export const PalletType = {
	BPL: 0,
	EPL: 1,
};
